<template>
  <Modal :show="show" role="alertdialog" :size="size">
    <form
      @submit.prevent="openReasonModal"
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-text="__(`Delete Order`)" />
        <ModalContent>
          <p class="leading-normal">
            {{
              __(
                'Are You Sure You Want To Delete This Order?'
              )
            }}
          </p>
        </ModalContent>
      </slot>

      <ModalFooter>
        <div class="ml-auto">
          <LinkButton
            type="button"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
            class="mr-3"
          >
            {{ __('No') }}
          </LinkButton>

          <Button
            type="submit"
            ref="confirmButton"
            dusk="confirm-delete-button"
            state="danger"
            :label="__('Yes')"
          />
        </div>
      </ModalFooter>
    </form>
  </Modal>
  <Modal :show="showReasonModal" role="alertdialog" size="lg">
    <form
      @submit.prevent="handleConfirm"
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-text="__(`Delete Order`)" />
        <ModalContent>
            <p class="leading-normal">
                {{ __('Describe The Reason For Deleting This Order?') }}
            </p>
        </ModalContent>
      </slot>

        <div class="px-8 pb-8">
            <label for="reason" class="inline-block text-80 pt-2 leading-tight mb-2">Reason:
                <span class="text-danger text-sm"> *</span>
            </label>
            <textarea
                id="reason"
                type="text"
                style="height: 150px; resize: none"
                v-model="reason"
                :class="{ 'border-red-500': reasonError }"
                :minlength="minReasonLength"
                class="w-full form-control form-input form-input-bordered py-2"
            />
            <small class="text-muted">(Reason should be at least 15 characters.)</small>
            <span v-if="reasonError" class="text-red-500 text-sm">{{ reasonError }}</span>
        </div>

      <ModalFooter>
        <div class="ml-auto">
          <LinkButton
            type="button"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
            class="mr-3"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            type="submit"
            ref="confirmButton"
            dusk="confirm-delete-button"
            :disabled="reason.length < minReasonLength"
            :loading="working"
            state="danger"
            :label="__(uppercaseMode)"
          />
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import startCase from 'lodash/startCase'
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },

    mode: {
      type: String,
      default: 'delete',
      validator: function (value) {
        return ['force delete', 'remove', 'delete', 'detach'].indexOf(value) !== -1
      },
    },
  },

  data: () => ({
      working: false,
      reason: '',
      reasonError: '',
      minReasonLength: 15, // Set the minimum reason length
      showReasonModal: false,
  }),

  watch: {
    showReasonModal(showing) {
      if (showing === false) {
        this.working = false
      }
    },
  },

  methods: {
    openReasonModal() {
      this.$emit('close')
      this.showReasonModal = true
    },
    handleClose() {
      this.$emit('close')
      this.showReasonModal = false
      this.working = false
    },

    closeReasonModal() {
      this.showReasonModal = false
    },

    handleConfirm() {
        if (this.reason.length < this.minReasonLength) {
            this.reasonError = `Reason should be at least ${this.minReasonLength} characters.`;
            return;
        }
        this.reasonError = '';
        this.$emit('confirm', this.reason)
        this.working = true
    },
  },

  /**
   * Mount the component.
   */
  mounted() {
    this.$nextTick(() => {
      // this.$refs.confirmButton.button.focus()
    })
  },

  computed: {
    uppercaseMode() {
      return startCase(this.mode)
    },
  },
}
</script>
